import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import {getMaxImageSize} from '../../../../config/app';
import API from '../lib/api';
import {defaultCampaignCoverImg} from 'assets/images';
import {displayAlert} from '../actions/app';
import i18n from 'i18n';
import {Img} from 'apps/shared/components';

const MAX_IMAGE_SIZE = getMaxImageSize();

const CoverUpload = createClass({
  propTypes: {
    value: PropTypes.string,
    img: PropTypes.string,
    onChange: PropTypes.func,
    type: PropTypes.oneOf(['cover', 'instagram'])
  },

  getDefaultProps() {
    return {
      img: defaultCampaignCoverImg,
      type: 'cover'
    };
  },

  onSelectImage(event) {
    let uploadData = {};

    if (!event.target.files[0]) return;

    uploadData.file = event.target.files[0];
    if (uploadData.file.size > MAX_IMAGE_SIZE) return this.onMaxFileSizeExceeded();

    uploadData.type = 'CampaignCover';

    API.uploadImage(uploadData, (err, res) => {
      if (err || !res.data) return console.error(err, res);
      if (this.props.onChange) this.props.onChange(res.id, res.data.url);
    });
  },

  onMaxFileSizeExceeded() {
    this.clearUploadInputVal();

    displayAlert({
      type: 'warning',
      title: i18n.get('UPLOAD_IMAGE_UPLOAD_WARNING_TITLE'),
      message: i18n.get('UPLOAD_IMAGE_UPLOAD_WARNING_MESSAGE')
    });
  },

  clearUploadInputVal() {
    this.imageInput.value = null;
  },

  render() {
    let {img, value, type} = this.props;

    return (
      <div
        className={'vf-clickable vf-cover-upload vf-cover-upload-' + type}
        onClick={() => this.imageInput.click()}>

          <Img
            src={img}
            className='image-cover image-fit-parent'
            height={260}
          />
          <div className='vf-icon icon-cloud-upload' />

          <input
            className='vf-cover-upload-input'
            ref={ref => this.imageInput = ref}
            type='file'
            accept='image/jpeg,image/bmp,image/png'
            onChange={this.onSelectImage}
          />
      </div>
    );
  }

});

module.exports = CoverUpload;
